// 간단한 암호화/복호화 유틸리티
// 실제 프로덕션에서는 더 강력한 암호화 방식을 사용해야 합니다.

const ENCRYPTION_KEY = "olzoom_secure_key_2024"; // 실제로는 환경변수로 관리해야 함

// 간단한 XOR 암호화 (실제 프로덕션에서는 AES 등을 사용)
const encrypt = (text) => {
  try {
    let result = "";
    for (let i = 0; i < text.length; i++) {
      const charCode =
        text.charCodeAt(i) ^
        ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length);
      result += String.fromCharCode(charCode);
    }
    return btoa(result); // Base64 인코딩
  } catch (error) {
    console.error("암호화 실패:", error);
    return null;
  }
};

const decrypt = (encryptedText) => {
  try {
    const decoded = atob(encryptedText); // Base64 디코딩
    let result = "";
    for (let i = 0; i < decoded.length; i++) {
      const charCode =
        decoded.charCodeAt(i) ^
        ENCRYPTION_KEY.charCodeAt(i % ENCRYPTION_KEY.length);
      result += String.fromCharCode(charCode);
    }
    return result;
  } catch (error) {
    console.error("복호화 실패:", error);
    return null;
  }
};

// 자격증명 저장 (아이디, 비밀번호, 저장 날짜)
export const saveCredentials = (username, password) => {
  try {
    const credentials = {
      username: encrypt(username),
      password: encrypt(password),
      savedAt: new Date().toISOString(),
      version: "1.0", // 향후 버전 관리용
    };

    localStorage.setItem("savedCredentials", JSON.stringify(credentials));
    return true;
  } catch (error) {
    console.error("자격증명 저장 실패:", error);
    return false;
  }
};

// 자격증명 불러오기 (1달 체크 포함)
export const loadCredentials = () => {
  try {
    const savedData = localStorage.getItem("savedCredentials");
    if (!savedData) {
      return null;
    }

    const credentials = JSON.parse(savedData);

    // 1달(30일) 체크
    const savedDate = new Date(credentials.savedAt);
    const currentDate = new Date();
    const daysDiff = (currentDate - savedDate) / (1000 * 60 * 60 * 24);

    if (daysDiff > 30) {
      localStorage.removeItem("savedCredentials");
      return null;
    }

    // 복호화
    const decryptedUsername = decrypt(credentials.username);
    const decryptedPassword = decrypt(credentials.password);

    if (!decryptedUsername || !decryptedPassword) {
      console.error("자격증명 복호화 실패");
      localStorage.removeItem("savedCredentials");
      return null;
    }

    return {
      username: decryptedUsername,
      password: decryptedPassword,
      savedAt: credentials.savedAt,
      daysRemaining: Math.floor(30 - daysDiff),
    };
  } catch (error) {
    console.error("자격증명 불러오기 실패:", error);
    localStorage.removeItem("savedCredentials");
    return null;
  }
};

// 자격증명 삭제
export const clearCredentials = () => {
  try {
    localStorage.removeItem("savedCredentials");
    return true;
  } catch (error) {
    console.error("자격증명 삭제 실패:", error);
    return false;
  }
};

// 저장된 자격증명 상태 확인
export const getCredentialsStatus = () => {
  try {
    const savedData = localStorage.getItem("savedCredentials");
    if (!savedData) {
      return { exists: false };
    }

    const credentials = JSON.parse(savedData);
    const savedDate = new Date(credentials.savedAt);
    const currentDate = new Date();
    const daysDiff = (currentDate - savedDate) / (1000 * 60 * 60 * 24);

    return {
      exists: true,
      savedAt: credentials.savedAt,
      daysRemaining: Math.floor(30 - daysDiff),
      isExpired: daysDiff > 30,
    };
  } catch (error) {
    console.error("자격증명 상태 확인 실패:", error);
    return { exists: false };
  }
};

// 저장된 자격증명의 날짜 업데이트 (자동 로그인 성공 시)
export const updateCredentialsDate = () => {
  try {
    const savedData = localStorage.getItem("savedCredentials");
    if (!savedData) {
      return false;
    }

    const credentials = JSON.parse(savedData);
    credentials.savedAt = new Date().toISOString(); // 현재 시간으로 업데이트

    localStorage.setItem("savedCredentials", JSON.stringify(credentials));
    return true;
  } catch (error) {
    console.error("자격증명 날짜 업데이트 실패:", error);
    return false;
  }
};
